const ecommerceConfig = [
  {
    path: "/ecommerce/settings",
    name: "ecommerce.settings",
    component: () => import("@/modules/Ecommerce/views/StoreSettingsPage.vue"),
    meta: {
      env: ["production"],
      pageTitle: "Configuraçães da loja",
      roles: [1, 2, 5, 6],
    }
  },
  {
    path: "/home-editor",
    name: "ecommerce.home-editor",
    component: () => import("@/modules/Ecommerce/views/HomePageEditor.vue"),
    meta: {
      roles: [5,1],
      layout: "full"
    }
  },
  {
    path: '/ecommerce/store/settings',
    name: 'ecommerce.settings.store.show',
    component: () => import('@/modules/Ecommerce/views/StoreSettings.vue'),
    meta: {
      roles: [1, 2, 5, 6],
    }
  },
  {
    path: "/ecommerce/onboarding",
    name: "ecommerce.onboarding",
    component: () => import("@/modules/Ecommerce/views/OnboardingPage.vue"),
    meta: {
      roles: [1, 2, 5, 6],
      layout: "full",
      env: ["production"],
      pageTitle: "Onboarding da Loja"
    }
  },


];
export default ecommerceConfig;
